import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "field"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.hasSelectTarget && this.hasFieldTarget) {
      const showField = this.selectTarget.value === 'Other'
      this.fieldTarget.style.display = showField ? '' : 'none'
    }
  }
}
